import guardrailLogo from '@/assets/negative-horizontal.svg';

interface ReportHeaderProps {
  reportId: string;
  reportDate: string;
  pluginName: string;
  branch?: string;
  classification?: string;
}

const ReportHeader = ({
  reportId,
  reportDate,
  pluginName,
  branch,
  classification = 'Confidential',
}: ReportHeaderProps) => {
  return (
    <div className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-8 mb-8 animate-fade-in">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-6">
          <img src={guardrailLogo} alt="AI Traffic Light" className="h-16 w-auto p-2" />
          <div>
            <h1 className="text-3xl font-bold tracking-tight text-white">
              AI Risk Assessment Report
            </h1>
            <p className="text-zinc-300 mt-1 text-lg">Plugin & Agent Security Analysis</p>
          </div>
        </div>
        <div className="text-right text-sm space-y-1">
          <div className="bg-zinc-800/50 backdrop-blur-sm rounded-lg px-4 py-2 inline-block border border-zinc-700">
            <span className="text-zinc-400">Classification:</span>{' '}
            <span className="font-semibold text-white">{classification}</span>
          </div>
        </div>
      </div>

      <div className="mt-8 grid grid-cols-3 gap-6">
        <div className="bg-zinc-800/50 backdrop-blur-sm rounded-lg p-4 border border-zinc-700">
          <p className="text-zinc-400 text-xs uppercase tracking-wider mb-1">Label</p>
          <p className="font-semibold text-lg text-white">
            {pluginName}
            {branch && <> @ <span className="font-mono text-zinc-300">{branch}</span></>}
          </p>
        </div>
        <div className="bg-zinc-800/50 backdrop-blur-sm rounded-lg p-4 border border-zinc-700">
          <p className="text-zinc-400 text-xs uppercase tracking-wider mb-1">Report ID</p>
          <p className="font-mono font-semibold text-white">{reportId}</p>
        </div>
        <div className="bg-zinc-800/50 backdrop-blur-sm rounded-lg p-4 border border-zinc-700">
          <p className="text-zinc-400 text-xs uppercase tracking-wider mb-1">Report Date</p>
          <p className="font-semibold text-white">{reportDate}</p>
        </div>
      </div>
    </div>
  );
};

export default ReportHeader;
